import React, {FunctionComponent} from 'react';
import {IActivityXpedition} from '../../redux/activities/interfaces';
import {FormattedMessage} from 'react-intl';
import {
  activityJournalsAsyncActions,
  removeActivityJournal
} from '../../redux/pageAsyncActions';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';

import './styles.scss';

interface IActivityJournalCardProps {
  journal: IActivityXpedition;
}

export const ActivityJournalCard: FunctionComponent<IActivityJournalCardProps> = ({
  journal
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showStart = !journal.dialogId;
  const showContinue = !showStart;
  const isCompleted = journal.percentage === 100;

  function handleStartActivity() {
    navigate(`/activity-journal/${journal.xpeditionId}`);
  }

  async function handleRemoveActivity() {
    dispatch(activityJournalsAsyncActions[removeActivityJournal](journal.dialogId));
  }

  const getCardClass = () => {
    if (journal.percentage === 100) {
      return 'completed';
    }
    if (journal.dialogId) {
      return 'in-progress';
    }

    return '';
  };

  return (
    <article className={`activity-journal-card ${getCardClass()}`}>
      <div
        style={{
          height: 180,
          backgroundImage: `url(${journal.imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      <div className="activity-journal-card__body">
        <div className="activity-journal-card__title">{journal.theme}</div>
        <div className="activity-journal-card__desc">{journal.description}</div>

        <div className="activity-journal-card__actions">
          <div style={{width: '100%'}}>
            <div className="progress-bar">
              <div className={`progress-fill ${isCompleted ? 'completed' : ''}`} style={{width: `${journal.percentage}%`}} />
            </div>
          </div>
          <div style={{display: 'flex', gap: 8, width: '100%'}}>
            {showStart && <button className="btn primary"
              onClick={handleStartActivity}>
              <FormattedMessage
                id={'gritx.activityJournals.start'}
                defaultMessage="Start"
              />
            </button>}
            {showContinue && <button className="btn primary"
              onClick={handleStartActivity}>
              <FormattedMessage
                id={'gritx.activityJournals.continue'}
                defaultMessage="Continue"
              />
            </button>}
            {journal.dialogId && <button className="btn secondary"
              onClick={handleRemoveActivity}>
              <FormattedMessage
                id={'gritx.activityJournals.startOver'}
                defaultMessage="Start Over"
              />
            </button>}
          </div>
        </div>
      </div>
    </article>
  );
};

